// extracted by mini-css-extract-plugin
export default {"badge":"TechBadge_badge__RzAUN","dark":"TechBadge_dark__k+d4F","light":"TechBadge_light__ZGnNN"};